<mat-dialog-content *ngIf="node">
  <div class="modal-header">
    <h4 class="modal-title pull-left" *ngIf="parentNode">Create Inside {{parentNode.get('name')}} Folder</h4>
    <h4 class="modal-title pull-left" *ngIf="!parentNode">Create New Root Folder</h4><i class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body">
    <form #catalogForm="ngForm">
      <div class="col-xs-12">
        <label class="col-xs-12 mt-0">Type</label>
        <div class="col-xs-12">
          <input-select [parseObj]="node" name="type" [options]="types" [required]="true" (onValueChanged)="isFolder = appConfig.Shared.EmbeddedLink.Type.Folder === $event"></input-select>
        </div>
      </div>
      <div class="col-xs-12">
        <label class="col-xs-12">Name</label>
        <div class="col-xs-12">
          <input-text [parseObj]="node" name="name" required="true"></input-text>
        </div>
      </div>
      <div class="col-xs-12" *ngIf="isFolder">
        <label class="col-xs-12">Allowed Roles</label>
        <input class="form-control" type="text" placeholder="Search Role" matInput="matInput" name="add_Role" autocomplete="off" [formControl]="autoCompleteRoleController" [matAutocomplete]="roleAuto" />
          <mat-autocomplete class="search-bar-xs" #roleAuto="matAutocomplete" (optionSelected)="onRoleSelect($event.option.value)">
            <mat-option *ngFor="let role of RoleOptions | async" [value]="role.object">
              {{ role.name }}
            </mat-option>
          </mat-autocomplete>
      </div>
      <span class="badge mr-2 bg-secondary mt-3" *ngFor="let role of allowedRoles; let i = index">{{role.get('name')}}
        <i class="fa fa-trash-o pointer ml-2" (click)="removeRole(i)"></i>
      </span>
      <div class="col-xs-12" *ngIf="!isFolder">
        <label class="col-xs-12">Link</label>
        <div class="col-xs-12">
          <input-text [parseObj]="node" name="link" required="true"></input-text>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="pull-right" [disabled]="catalogForm.invalid" (click)="updateOrCreateNode()">{{node.id ? "Update" : "Create" }}</button>
  </div>
</mat-dialog-content>